import React, { useState, useEffect } from "react";
import { Tab } from "@headlessui/react";
import { motion, Variants } from "framer-motion";
import {
    CircleStackIcon,
    AcademicCapIcon,
    BuildingOfficeIcon
} from "@heroicons/react/24/outline";
// import { useGSAP } from '@gsap/react';

// gsap.registerPlugin(useGSAP, ScrollTrigger);

// export default function Scroll() {
//   const main = useRef();
//
//   useGSAP(
//     () => {
//       const boxes = gsap.utils.toArray('.box');
//       boxes.forEach((box) => {
//         gsap.to(box, {
//           x: 150,
//           scrollTrigger: {
//             trigger: box,
//             start: 'bottom bottom',
//             end: 'top 20%',
//             scrub: true,
//             // markers: true,
//           },
//         });
//       });
//     },
//     { scope: main }
//   );
//
//   return (
//     <div>
//       <section className="section flex-center column">
//         <h2>Basic ScrollTrigger with React</h2>
//         <p>Scroll down to see the magic happen!!</p>
//       </section>
//       <div className="section flex-center column" ref={main}>
//         <div className="box gradient-blue">box</div>
//         <div className="box gradient-blue">box</div>
//         <div className="box gradient-blue">box</div>
//       </div>
//       <section className="section"></section>
//     </div>
//   );
// }


function classNames(...classes: any) {
    return classes.filter(Boolean).join(" ");
}

const tabs: any = {
    "디지털 트렌스포메이션": [
        {
            no: 1,
            eng: "Digital Transformation",
            title: "디지털 트렌스포메이션",
            description:
                "정보화 시대에 맞추어 전통산업의 Digital Transformation을 위해 Cloud 기반의 SaaS(Software as a Service), PaaS(Platform as a Service) 제공",
            imgSrc: "/img/sales-overview-products.png",
            styles: "translate-x-0",
            transform: { transform: "translateX(0)" },
            icon: (
                <CircleStackIcon
                    stroke="currentColor"
                    className="h-6 w-6 stroke-white"
                />
            )
        }
    ],
    "ICT 융합기술": [
        {
            no: 2,
            eng: "ICT Convergence Technology",
            title: "ICT 융합기술 R&D / 기술사업화",
            description:
                "기존산업에 접목할 수 있는 ICT분야의 융합기술 및 시스템을 기획하고 개발 컨설팅하고, 대학원천기술을 상용화할 수 있는 ICT융합 사업을 기획하고 사업화합니다.",
            imgSrc: "/img/main_con01.png",
            styles: "-translate-x-[200%]",
            transform: { transform: "translateX(-100%)" },
            icon: (
                <AcademicCapIcon
                    stroke="currentColor"
                    className="h-6 w-6 stroke-white"
                />
            )
        }
    ],
    "서비스 인큐베이션": [
        {
            no: 4,
            eng: "Service Incubation",
            title: "서비스 인큐베이션",
            description: "창의적인 ICT융합사업 아이디어를 인큐베이팅합니다.  ",
            imgSrc: "/img/main_con02.png",
            styles: "-translate-x-[300%]",
            transform: { transform: "translateX(-300%)" },
            icon: (
                <BuildingOfficeIcon
                    stroke="currentColor"
                    className="h-6 w-6 stroke-white"
                />
            )
        }
    ]
};

const mainContents = [
    {
        no: 1,
        eng: "ICT Convergence Technology",
        title: "ICT 융합기술 R&D / 기술사업화",
        description:
            "기존산업에 접목할 수 있는 ICT분야의 융합기술 및 시스템을 기획하고 개발 컨설팅하고, 대학원천기술을 상용화할 수 있는 ICT융합 사업을 기획하고 사업화합니다.",
        imgSrc: "/img/main_con01.svg",
    },
    {
        no: 2,
        eng: "Service Incubation",
        title: "서비스 인큐베이션",
        description: "창의적인 ICT융합사업 아이디어를 인큐베이팅합니다.  ",
        imgSrc: "/img/main_con02.svg",
    }
]

const cardVariants: Variants = {
    offscreen: {
        y: 100
    },
    onscreen: {
        y: 0,
        transition: {
            type: "spring",
            duration: 0.8
        }
    }
};
const TabMain = () => {
    const [categories] = useState(tabs);
    const tabsKeys = Object.keys(tabs);
    const [clickedButton, setClickedButton] = useState(tabs);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const button: HTMLButtonElement = event.currentTarget;
        setClickedButton(button.name);
    };
    return (
        <section
            id="tab"
            className="scroll-mt-below-header md:scroll-mt-below-header-md"
        >
            <motion.div className="main-container m-auto max-w-screen-lg bg-white px-5 pt-16 sm:pt-[100px] xl:px-0">
                <Tab.Group defaultIndex={0}>
                    <div className="relative">
                        <div
                            aria-hidden="true"
                            className="pointer-events-none absolute inset-x-0 top-0 hidden rounded-2xl bg-[#ebf4ff] sm:block sm:h-[30rem] lg:h-[36rem]"
                        />

                        <div className="relative sm:px-14 sm:pt-14">
                            <h3 className="text-left text-lead font-medium text-brand sm:text-center">
                                Digital Transformation
                            </h3>
                            <p className="pb-4 pt-1 text-left text-h1 font-bold sm:text-center">
                                디지털 트렌스포메이션
                            </p>
                            <p className="text-balance text-left text-body sm:text-center">
                                정보화 시대에 맞추어 전통산업의 Digital
                                Transformation을 위해{" "}
                                <br className="hidden sm:block" />
                                Cloud 기반의 SaaS(Software as a Service),
                                PaaS(Platform as a Service) 제공
                            </p>
                        </div>

                        <div className="relative mx-auto mt-8 w-full rounded-lg sm:mt-10 sm:w-[80%] sm:bg-white sm:px-4 sm:py-14 sm:shadow-xl">
                            <img
                                className="w-full"
                                src="/img/dt-process-img.png"
                                alt=""
                            />
                        </div>
                    </div>

                    <div className="mt-20 max-w-7xl sm:mt-40">
                        <div className="main_con grid grid-cols-1 gap-16 sm:gap-20">
                            {mainContents.map((list, index) => (
                                <div
                                    key={list.no}
                                    className={`flex flex-col items-center justify-between sm:gap-20 ${
                                        index % 2 === 1
                                            ? "sm:flex-row-reverse"
                                            : "sm:flex-row"
                                    }`}
                                >
                                    <div className="w-full sm:w-[48%]">
                                        <h3 className="text-left text-lead font-medium text-brand">
                                            {list.eng}
                                        </h3>
                                        <h2 className="text-balance text-h1 font-bold">
                                            {list.title}
                                        </h2>
                                        <p className="mt-4 text-body sm:mt-6">
                                            {list.description}
                                        </p>
                                    </div>

                                    <div className="con_img mt-8 w-full rounded-2xl sm:mt-0 sm:h-[340px] sm:w-[48%]">
                                        <img
                                            className="h-full w-full object-contain sm:ml-4 sm:w-[70%]"
                                            src={list.imgSrc}
                                            alt=""
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Tab.Group>
            </motion.div>
        </section>
    );
};
export default TabMain;
